// extracted by mini-css-extract-plugin
export default {"modules":"McBarChart_modules__V3Jm6","navbar":"McBarChart_navbar__a3glS","navbar0":"McBarChart_navbar0__w4Smq","view":"McBarChart_view__7V4vQ","module":"McBarChart_module__pbf5F"};